/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/view/Index'//首页
import feedBack from '@/view/feedBack'//feedback页面
import acceptLoan from '@/view/acceptLoan'//贷款产品offer页面
import informationConfirmed from '@/view/informationConfirmed'//企业信息确认页面
import certified from '@/view/certified'//关联人认证授权
import login from '@/view/login'//登录页面
import stepDescription from '@/view/stepDescription'//步骤说明


import linkPeople from '@/view/linkPeople'//关联人信息
import editAgain from '@/view/editAgain'//登录信息

import editperson from '@/view/editperson'//修改关联人信息
import peopleVerification from '@/view/peopleVerification'//关联人信息
import complete from '@/view/complete'//关联人授权成功
import corpLegalFail from '@/view/corpLegalFail'//实名认证失败，有剩余次数 后端返回信息
import cupLoginTip from '@/view/cupLoginTip'//请勿重复提交
Vue.use(Router)
export default new Router({
    //静态路由
    routes: [{
        path: '/',
        name: 'Index',
        component: Index
    },{
        path: '/index',
        name: 'Index',
        component: Index
    },{
        path: '/feedBack',
        name: 'feedBack',
        component: feedBack
    },{
        path: '/certified',
        name: 'certified',
        component: certified
    },{
        path: '/stepDescription',
        name: 'stepDescription',
        component: stepDescription
    },{
        path: '/linkPeople',
        name: 'linkPeople',
        component: linkPeople
    },{
        path: '/editAgain',
        name: 'editAgain',
        component: editAgain
    },{
        path: '/editperson',
        name: 'editperson',
        component: editperson
    },{
        path: '/peopleVerification',
        name: 'peopleVerification',
        component: peopleVerification
    },{
        path: '/complete',
        name: 'complete',
        component: complete
    },{
        path: '/informationConfirmed',
        name: 'informationConfirmed',
        component: informationConfirmed
    },{
        path: '/acceptLoan',
        name: 'acceptLoan',
        component: acceptLoan
    },{
        path: '/login',
        name: 'login',
        component: login
    },{
        path: '/corpLegalFail',
        name: 'corpLegalFail',
        component: corpLegalFail
    },{
        path: '/cupLoginTip',
        name: 'cupLoginTip',
        component: cupLoginTip
    }
    
]
})



// WEBPACK FOOTER //
// ./src/router/index.js